import { useContext } from "react"
import { PageLifecycleContext } from "./PageLifecycleContext"

export function usePageLifecycleContext() {
  return useContext(PageLifecycleContext)
}
